import React from 'react'

export default class Controller extends React.PureComponent {
  // 回首页
  gotoHomepage = () => {
    this.props.history.push('/')
  }
}
